module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "pz6-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('b', [_vm._v("A Mayberry Grace")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "txc",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "id": "pz6-2"
    }
  }, [_vm._v("Give us, Lord, a bit o’ sun,"), _c('br'), _vm._v(" A bit o’ work, and a bit o’ fun."), _c('br'), _vm._v(" Give us all in the struggle and splutter,"), _c('br'), _vm._v(" Our daily bread and a bit o’ butter.")]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz6-6"
    }
  }, [_c('i', [_vm._v("Origin unknown, submitted by Margie Mode"), _c('br'), _vm._v(" Clarksville, Indiana")])]), _vm._v(" "), _c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "pz6-8"
    }
  }, [_c('b', [_vm._v("A Favorite Recipe")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz6-9"
    }
  }, [_c('i', [_vm._v("Good for All Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz6-10"
    }
  }, [_vm._v("Take a cup of kindness,"), _c('br'), _vm._v(" And mix it well with love."), _c('br'), _vm._v(" Add a lot of patience,"), _c('br'), _vm._v(" And faith in God above."), _c('br'), _vm._v(" Sprinkle very generously with"), _c('br'), _vm._v(" Joy and thanks and cheer."), _c('br'), _vm._v(" And you’ll have lots of angel food"), _c('br'), _vm._v(" To feast on all the year!")]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz6-18"
    }
  }, [_c('i', [_vm._v("Submitted by Wanda C. Fields from her church cookbook"), _c('br'), _vm._v(" Reidsville, North Carolina")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pz6-20"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-6-1.jpg",
      "id": "z6-20",
      "src": "images/img-6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pApi"
    }
  }, [_c('i', [_vm._v("Aunt Bee")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b762c80e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 69
// module chunks = 0